// VITE_HITFACTOR_URL is the canonical name; VITE_RANKSHOOT_URL is accepted
// as a legacy fallback so existing deployments keep working after the rename.
const HITFACTOR_URL =
  import.meta.env.VITE_HITFACTOR_URL ||
  import.meta.env.VITE_RANKSHOOT_URL ||
  'http://localhost:3000';

export const CONFIG = {
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1',
  HITFACTOR_URL,
  /** @deprecated use `HITFACTOR_URL` — kept for older call sites. */
  RANKSHOOT_URL: HITFACTOR_URL,
  DESIGNER_URL: import.meta.env.VITE_DESIGNER_URL || 'http://localhost:3002',
  AUTO_SAVE_INTERVAL_MS: 30_000,
  MAX_HISTORY_SIZE: 50,
  MAX_DIAGRAM_SIZE_BYTES: 5 * 1024 * 1024,
  THUMBNAIL_WIDTH: 400,
  THUMBNAIL_HEIGHT: 300,
  DEFAULT_CANVAS_WIDTH_M: 30,
  DEFAULT_CANVAS_HEIGHT_M: 20,
  DEFAULT_GRID_SIZE_M: 1,
  MIN_ZOOM: 0.1,
  MAX_ZOOM: 5.0,
};
